import { Link } from "react-router-dom";
import { useAuth } from "../auth.js";

export function HomePage() {
  const auth = useAuth();
  return (
    <div className="max-w-md mx-auto p-6 space-y-6">
      <header className="flex items-center justify-between">
        <h1 className="text-xl font-bold">MMA Stats Tracker</h1>
        <button
          onClick={() => auth.logout()}
          className="text-sm text-neutral-400 hover:text-neutral-200"
        >
          Log ud ({auth.role})
        </button>
      </header>

      <div className="space-y-3">
        <Link
          to="/spotter"
          className="block bg-blue-600 hover:bg-blue-500 rounded-2xl p-6 text-center text-xl font-semibold"
        >
          Spotter — registrer live kamp
        </Link>
        <Link
          to="/history"
          className="block bg-neutral-800 hover:bg-neutral-700 rounded-2xl p-6 text-center"
        >
          Historik & eksport
        </Link>
        {auth.role === "admin" && (
          <Link
            to="/admin"
            className="block bg-neutral-800 hover:bg-neutral-700 rounded-2xl p-6 text-center"
          >
            Admin — events & kampe
          </Link>
        )}
      </div>
    </div>
  );
}
